import React from "react";
import { Provider } from "react-redux";
import store from "web/redux/store";
import PropTypes from "prop-types";

// Used to wrap a react component in a Redux provider

export default function withRedux(WrappedComponent) {
    return function withRedux(props) {
        return (
            <Provider store={store}>
                <WrappedComponent {...props} />
            </Provider>
        );
    };
}

withRedux.propTypes = {
    children: PropTypes.node.isRequired,
};
